<template>
  <div class="data-limit">
    <a-button-box :active="state.matches('notifyDataLimit.visible')">
      <a-button ref="toggle" variant="link-primary" class="btn-main" @click="toggleHandler">
        <a-icon color="red" name="danger" :width="24" :height="24" />
      </a-button>
    </a-button-box>
    <Transition name="fade">
      <div class="box mb--0 mt--1" v-show="state.matches('notifyDataLimit.visible')" ref="target">
        <div class="box__header">
          {{ $t('alert.notifyDataLimit') }}
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import {ref} from 'vue'
import {useMeetingMachine} from '@/state'
import AButtonBox from '@/components/AButtonBox.vue'
import {onClickOutside} from '@vueuse/core'

const {state, send} = useMeetingMachine()
const toggle = ref(null)
const target = ref(null)

function toggleHandler() {
    if (state.value.matches('notifyDataLimit.visible')) {
      send('HIDE_MESSAGE_DATA_LIMIT')
    } else {
      send('SHOW_MESSAGE_DATA_LIMIT')
    }
}
onClickOutside(target, event => {
  if (state.value.matches('notifyDataLimit.visible') && event.target !== toggle.value.$el) {
    send('HIDE_MESSAGE_DATA_LIMIT')
  }
})
</script>

<style lang="scss">
$participants-max-width: calc(100vw - #{$box-spacer * 2});

.data-limit {
  position: relative;
  .box {
    position: absolute;
    top: 100%;
    right: 0;
    max-width: $participants-max-width;
    max-height: calc(
      100dvh - #{$component-height + $box-spacer + map-get($spacers, 2)} - 3.625rem
    ); // TODO: tools height variable
    overflow: auto;

    &__header {
      width: 230px;
      padding: $box-spacer-md;
    }
  }
}
</style>
